<template>
  <div>

    <div class="topbar"><div class="wrap">
      <span>欢迎访问辽宁师范高等专科学校思政教育一体化平台</span>
      <div class="tb-right" id="authBar">
        <template v-if="isLogin">
          <span class="tb-user">您好，{{ name }}（{{ type === 1 ? '教师' : '学生' }}）<span v-if="type === 2 && classname !== ''" class="class-badge">{{ classname || '未分配班级' }}</span></span><a class="tb-quit" @click="handleLogout()">退出</a>
        </template>
        <template v-else>
          <a class="tb-btn" @click="openLogin('teacher')">教师登录</a>
          <a class="tb-btn" style="background:#fff;color:var(--red)" @click="openLogin('student')">学生登录</a>
        </template>
      </div>
    </div></div>

    <header class="site"><div class="wrap">
      <div class="head-inner">
        <img class="logo-mark" :src="logo" alt="">
        <div class="head-title"><h1>辽宁师范高等专科学校思政教育一体化平台</h1><p>LIAONING TEACHERS COLLEGE INTEGRATED POLITICAL EDUCATION PLATFORM</p></div>
        <div class="head-search">
          <img class="search-icon" :src="icons.search" alt="" style="width:18px;height:18px">
          <input id="kw" v-model="headerSearchText" placeholder="搜索新闻、政策、课程..." @keydown.enter="doSearch(headerSearchText)">
          <button @click="doSearch(headerSearchText)">搜索</button>
        </div>
      </div>
      <nav class="main"><div class="nav-inner" id="navBar">
        <router-link to="/home" :class="{active: activeNav === 'home'}">首页</router-link>
        <router-link to="/news" :class="{active: activeNav === 'news'}">新闻动态</router-link>
        <router-link to="/policy" :class="{active: activeNav === 'policy'}">政策文件</router-link>
        <router-link to="/topic" :class="{active: activeNav === 'topic'}">专题资源</router-link>
        <router-link to="/site" :class="{active: activeNav === 'site'}">赓续传承</router-link>
        <router-link to="/theory" :class="{active: activeNav === 'theory'}">理论研究</router-link>
        <router-link v-if="type === 1" to="/teacher_learning_task" :class="{active: activeNav === 'learning_task'}">学时管理</router-link>
        <router-link v-if="type === 2" to="/student_learning_task" :class="{active: activeNav === 'learning_task'}">学时管理</router-link>
      </div></nav>
    </div></header>

  </div>
</template>

<script>
import { logout } from "@/api/login";
import icons from '@/utils/icons'
import { mapState } from 'vuex';

export default {
  name: 'HeaderPage',
  computed: {
    ...mapState({
      isLogin: state => state.account.isLogin,
      username: state => state.account.username,
      name: state => state.account.name,
      avatar: state => state.account.avatar,
      type: state => state.account.type,
      classname: state => state.account.classname,
      nav: state => state.account.nav
    }),
  },
  data() {
    return {
      activeNav: mapState.nav || 'home',
      logo: require('@/assets/logo.png'),
      icons,
      headerSearchText: ''
    }
  },
  mounted() {
    this.syncActiveNav()
    this.$watch(
        () => this.$route.path,
        () => this.syncActiveNav()
    )
  },
  methods: {
    syncActiveNav() {
      const path = this.$route.path
      if (path === '/home' || path === '/') this.activeNav = 'home'
      else if (path === '/news' || path === '/news/detail') this.activeNav = 'news'
      else if (path === '/policy' || path === '/policy/detail') this.activeNav = 'policy'
      else if (path === '/topic' || path === '/topic/detail') this.activeNav = 'topic'
      else if (path === '/site' || path === '/site/detail') this.activeNav = 'site'
      else if (path === '/theory' || path === '/theory/detail') this.activeNav = 'theory'
      else if (path === '/teacher_learning_task' || path === '/teacher_learning_task_detail' || path === '/teacher_publish') this.activeNav = 'learning_task'
      else if (path === '/student_learning_task') this.activeNav = 'learning_task'
      else this.activeNav = ''
    },
    async handleLogout() {
      try {
        const res = await logout()
        if (res.code === 200) {
          this.$store.commit('logout')
          const redirect = '/'
          await this.$router.push(redirect)
        } else {
          this.$message({
            effect: 'error',
            message: 'Error：系统错误！'
          })
          return false
        }
      } catch (error) {
        console.error('登录失败:', error)
      }
    },
    async doSearch(keywords) {
      this.$router.push({
        path: '/search',
        query: { keywords }
      })
    }
  }
}
</script>
